import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import ContentPage from 'src/components/ContentPage/ContentPage';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import NotFoundPage from 'src/components/NotFoundPage/NotFoundPage';
import { SivaGoalsStatus } from 'src/api/v2';
import { Icon } from '@innovationnorway/cl-react';
import { ROUTES } from 'src/navigation';
import { useSivaGoalsDetailsList } from '../../hooks/use-siva-goals-details-list';
type Params = {
  year: string;
  clusterId: string;
};
const SivaAdminGoalsDetailsConfirmation: React.FC = () => {
  const { year, clusterId } = useParams<Params>();
  const { data, isLoading } = useSivaGoalsDetailsList(year ? parseInt(year) : undefined);
  const details = useMemo(() => {
    return data.find((x) => x.clusterId === clusterId);
  }, [clusterId, data]);
  const title = useMemo(() => {
    switch (details?.goalsStatus) {
      case SivaGoalsStatus.Approved:
        return 'Godkjent';
      case SivaGoalsStatus.ChangeRequested:
        return 'Sendt tilbake';
      default:
        return 'Ukjent status';
    }
  }, [details?.goalsStatus]);
  const description = useMemo(() => {
    switch (details?.goalsStatus) {
      case SivaGoalsStatus.Approved:
        return `Måltall ${year} til ${details?.clusterName} ble godkjent. De vil bli varslet.`;
      case SivaGoalsStatus.ChangeRequested:
        return `Måltall ${year} ble sendt tilbake til ${details?.clusterName}. De vil bli varslet.`;
      default:
        return 'Ukjent status på måltall, sjekk på nytt.';
    }
  }, [details?.clusterName, details?.goalsStatus, year]);
  if (!year || !clusterId) {
    return <NotFoundPage />;
  }
  if (isLoading) {
    return <LoadingPage aria-label="Henter data..." />;
  }
  if (!details) {
    return <NotFoundPage />;
  }
  return (
    <ContentPage title={title}>
      <p className="margin-bottom--8">{description}</p>

      <Link to={ROUTES.SIVA.ADMIN.GOALS.YEAR(year).BASE}>
        <Icon prefix="fasr" iconName="arrow-right" className="margin-right--1" />
        Gå til oversikten
      </Link>
    </ContentPage>
  );
};
export default SivaAdminGoalsDetailsConfirmation;
